/* Library */
import React, { Component } from 'react';
import commonUtil from '../../utils/commonUtil';
import Tagging from '../Tagging';
import { UIBrands2 } from '../../utils/clientConstant';
import { KAMPYLE_FORM_CODES } from '../../utils/clientConstant';


export default class VozCliente extends Component {

  constructor(props) {
    super(props);
  }
  
  getTaggingVozCliente = () => {
    const _dataLayer = {};
    _dataLayer.action = 'Te escuchamos';
    _dataLayer.section = 'Mesa de Regalos';
    this.props.page === 'mesas'  ? _dataLayer.screen_name = 'Acceso a Mesas' : _dataLayer.screen_name = 'Home';
    return _dataLayer;
  }

  vozCliente = () => {
    try {
      if(this.props.page !== "mesa"){
        const _dataLayer = this.getTaggingVozCliente();
        this.tagging.applyGTM('voz_cliente', _dataLayer);
      }

      const kampyleFormCode = KAMPYLE_FORM_CODES[commonUtil.getBrand()] || 13778; 
      KAMPYLE_ONSITE_SDK.showForm(kampyleFormCode);
    } catch (error) {
        console.log(error)
    }
  };

  render() {
      const currentBrand = commonUtil.getBrand();
      const existsInBrands = UIBrands2.some(brand => brand.id === currentBrand);
      
    return (
      <React.Fragment>

        { !existsInBrands ? null : (
          <React.Fragment>
            <Tagging ref={tagging => this.tagging = tagging} />
            <div className={commonUtil.getUserAggent()}>
              <button className="button_vozcliente" onClick={this.vozCliente}>
                <div className='animation_text_vozcliente'>
                  <span className='text_vozcliente'>Te escuchamos</span>
                </div>
                <div className="container-image">
                  <img src={commonUtil.getAssetURL() + '/images/vozCliente.svg'} alt="Logo Voz del Cliente" className="icon_vozcliente"/>
                </div>
              </button>  
            </div>
          </React.Fragment>
        )}

      </React.Fragment>
    );
  }
}
